import PropTypes from 'prop-types';
import { memo } from 'react';
import ReactTooltip from 'react-tooltip';
import { mergeClassName } from '@/lib/utils';

const TooltipText = ({
  id,
  text,
  message,
  className,
  event,
  allowHtml,
}) => (
  <div data-for={id} data-tip={message} className={mergeClassName('inline', event === 'click' ? 'cursor-pointer' : '')}>
    {text}
    <ReactTooltip
      className={mergeClassName('normal-case', className)}
      id={id}
      place="top"
      effect="solid"
      event={event}
      html={allowHtml}
    />
  </div>
);

TooltipText.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  message: PropTypes.string.isRequired,
  className: PropTypes.string,
  event: PropTypes.string,
  allowHtml: PropTypes.bool,
};

export default memo(TooltipText);
